import React, {useState, useEffect} from 'react';
import Select from "react-select";

import rootCauseIcon from "../../../../../resources/images/root-cause-icon.png";
import {NextButton} from "../../../../common/button/next-button/NextButton";
import {BackButton} from "../../../../common/button/back-button/BackButton";
import {BreadCrumbTrail} from "../../../../common/breadcrumb-trail/BreadcrumbTrail";
import {StandardButton} from "../../../../common/button/standard-button/StandardButton";
import {CommentToolTip} from "../../../../common/tool-tip-comments/CommentToolTip";
import {ToolTip} from "../../../../common/tool-tip/ToolTip";
import {retrieveAllChangeConcepts} from "../../../../../services/ChangeConceptService";

export const ChangeIdeaOne = ({
                                  context,
                                  setContext,
                                  navigateTo,
                                  navigateBack,
                                  setSpinnerText,
                                  showToaster,
                                  toolTipsEnabled
                              }) => {
    const [priorityOptions] = useState([
        {label: "Low", value: "Low"},
        {label: "Medium", value: "Medium"},
        {label: "High", value: "High"}
    ]);
    const [priority, setPriority] = useState({label: "Select...", value: null});
    const [changeConceptList, setChangeConceptList] = useState([]);
    const [changeConcept, setChangeConcept] = useState({label: "Select...", value: null});
    const [description, setDescription] = useState(null);
    const [title, setTitle] = useState(null);

    useEffect(() => {
        setSpinnerText("Retrieving Change Concepts");
        const fetchData = async () => {
            const [data] = await retrieveAllChangeConcepts(context.username);
            if (data) {
                if (data.responseStatus === "Success") {
                    const activeChangeConcepts = data.conceptVOList.filter(concept => concept.active);
                    const mappedChangeConcepts = activeChangeConcepts.map((changeConcept) => {
                        return {value: changeConcept.changeIdeaConcept, label: changeConcept.changeIdeaConcept};
                    });
                    setChangeConceptList(mappedChangeConcepts);
                }
            }
            setSpinnerText(null);
        }
        fetchData();

        if (context.viewMode) {
            if (!context.copyOfChangeIdeaScreen) {
                const copyOfChangeIdeaScreen = JSON.stringify(context.changeIdeaScreen);
                setContext((prevState) => ({
                    ...prevState,
                    copyOfChangeIdeaScreen,
                }));
            }
        }
    }, []);


    useEffect(() => {
        if (context.changeIdeaScreen) {
            const concept = context.changeIdeaScreen.changeConcept;
            if (concept) {
                setChangeConcept({label: concept, value: concept});
            }

            if (context.changeIdeaScreen.priority) {
                setPriority(context.changeIdeaScreen.priority);
            }

            if (context.changeIdeaScreen.description) {
                setDescription(context.changeIdeaScreen.description);
            }

            if (context.changeIdeaScreen.title) {
                setTitle(context.changeIdeaScreen.title);
            }
        }
    }, [context]);

    const handleNextClick = () => {
        setContext((prevState) => ({
            ...prevState,
            changeIdeaScreen: {
                ...prevState.changeIdeaScreen,
                changeConcept: changeConcept.label,
                description,
                priority,
                title,
            }
        }));
        navigateTo("changeIdeaTwo");
    }

    const isButtonDisabled = () => {
        return (!changeConcept.value || !priority.value || !description || description === "" || !title || title === "");
    }

    return (
        <div className="wizard-content-container">
            <div className="wizard-main-content-container">
                <div className="wizard-left-container">
                    <div className="wizard-icon-container">
                        <img src={rootCauseIcon} alt="Root Cause Icon" className="wizard-icon"/>
                    </div>
                    <p className="wizard-icon-label">{context.rootCauseScreen.name}</p>
                </div>
                <div className="wizard-right-container">
                    <div className="input-container">
                        <div>
                            <label>Change Concept:</label>
                            {toolTipsEnabled &&
                            <ToolTip tooltipExternalReference={"changeconcept1"}
                                     context={context}
                                     setSpinnerText={setSpinnerText} showToaster={showToaster}
                                     fieldName={"Change Concept:"}/>}
                        </div>
                        <Select options={changeConceptList}
                                onChange={(selectedChangeConcept) => {
                                    setChangeConcept(selectedChangeConcept)
                                }}
                                isDisabled={!changeConceptList || !context.editMode}
                                value={changeConcept}
                                classNamePrefix="select"
                        />
                    </div>
                    <div className="input-container">
                        <div>
                            <label>Change Idea Title:</label>
                            {toolTipsEnabled &&
                            <ToolTip tooltipExternalReference={"changeconcepttitle2"}
                                     context={context}
                                     setSpinnerText={setSpinnerText} showToaster={showToaster}
                                     fieldName={"Change Idea Title:"}/>}
                        </div>
                        <input className="text-input" disabled={!context.editMode} defaultValue={title ? title : null}
                               onChange={({target}) => setTitle(target.value)}
                        />
                    </div>
                    <div className="input-container">
                        <div>
                            <label>Change Idea:</label>
                            {toolTipsEnabled &&
                            <ToolTip tooltipExternalReference={"changeconceptdesc3"}
                                     context={context}
                                     setSpinnerText={setSpinnerText} showToaster={showToaster}
                                     fieldName={"Change Idea:"}/>}
                        </div>
                        <textarea disabled={!context.editMode} onChange={({target}) => {
                            setDescription(target.value)
                        }} defaultValue={description ? description : null}/>
                    </div>
                    <div className="input-container">
                        <div>
                            <label>Priority:</label>
                            {toolTipsEnabled &&
                            <ToolTip tooltipExternalReference={"changeconceptpriority2"}
                                     context={context}
                                     setSpinnerText={setSpinnerText} showToaster={showToaster}
                                     fieldName={"Priority:"}/>}
                        </div>
                        <Select options={priorityOptions}
                                onChange={(selectedPriority) => {
                                    setPriority(selectedPriority)
                                }}
                                isDisabled={!priorityOptions || !context.editMode}
                                value={{label: priority.label, value: priority.value}}
                                classNamePrefix="select"
                        />
                    </div>
                    {context.viewMode && context.changeIdeaScreen && context.changeIdeaScreen.externalReference &&
                    <CommentToolTip contextName={"Change Idea"} showToaster={showToaster}
                                    setSpinnerText={setSpinnerText}
                                    contextExternalReference={context.changeIdeaScreen.externalReference}
                                    context={context} toolTipsEnabled={toolTipsEnabled}/>}
                    {context.viewMode && <div className="back-to-overview-button-container">
                        <StandardButton text="Problem Overview" onClick={() => {
                            navigateTo("problemTree");
                        }}/>
                    </div>}
                    <div className="navigation-button-container">
                        <NextButton disabled={isButtonDisabled()} onClick={handleNextClick}/>
                        <BackButton onClick={navigateBack}/>
                    </div>
                </div>
            </div>

            <div className="wizard-breadcrumb-container">
                <BreadCrumbTrail context={context} navigateTo={navigateTo}/>
            </div>
        </div>
    );
}
